import ComponentBase from 'components/_base/ComponentBase';
import _ from 'underscore';

const SeeMapAndDetailsBtn = ComponentBase.extend(
  {

    template: require('./seeMapAndDetailsBtn.hbs'),

    events: {
      'click': 'toggleBtn'
    },

    identifier: 'jp-see-map-and-details-btn',

    constructor(options) {
        options.identifier = this.identifier;
        this.componentClass = options.componentClass;
        this.componentConstructorClass = options.componentConstructorClass;
        ComponentBase.prototype.constructor.call(this, options);
    },

    initialize(options) {
        this.bus = this.widget.bus;
        this.seeMapState = options.properties.seeMapState;
        this.templateConfig = _.extend(options, {
            componentClass: 'jp-see-map-and-details-btn',
            seeMapState: this.seeMapState
        });
        ComponentBase.prototype.initialize.call(this, options);
    },

    toggleBtn() {
        this.seeMapState = !this.seeMapState;
        this.templateConfig.seeMapState = this.seeMapState;
        this.$el.replaceWith(this.render().$el);
        this.parentComponent.collapseDetailsPanel(!this.seeMapState);
    }
  });

export default SeeMapAndDetailsBtn;



// WEBPACK FOOTER //
// ./src/components/seeMapAndDetailsBtn/SeeMapAndDetailsBtn.js